import classnames from 'classnames';
import firebase from 'firebase/app';
import React, { useCallback } from 'react';
import { createUseStyles } from 'react-jss';
import { useDispatch } from 'react-redux';

import { logoutUser } from '../../../redux/actions';

const useStyles = createUseStyles({
  button: {
    borderRadius: 4,
    composes: ['p12', 'text-center', 'mt6', 'fs14', 'is-full-width'],
    transition: 'background 0.3s',
  },
});

const LogoutButtonComponent = function LogoutButtonComponent() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const signoutHandler = useCallback(() => {
    firebase
      .auth()
      .signOut()
      .then(() => dispatch(logoutUser()))
      .catch(() => {});
  }, [dispatch]);

  return (
    <button
      className={classnames(classes.button, 'smart-maps-button-danger')}
      type="button"
      onClick={signoutHandler}>
      <span>Déconnexion</span>
    </button>
  );
};

LogoutButtonComponent.displayName = 'LogoutButtonComponent';

export default LogoutButtonComponent;
